import { ColorMode } from '@chakra-ui/react';
import { Appearance } from '@stripe/stripe-js';
import { StripeAccount } from './social';
import { PaginatedData } from './util';

export interface StripePaymentIntent {
    id: string;
    amount: number;
    created: number;
    currency: string;
    metadata: { [index: string]: string };
    status: string;
}

export interface StripeCreatePaymentIntentResponse {
    client_secret: string;
}

export interface StripeGetPaymentIntentResponse {
    data: StripePaymentIntent[];
    page: PaginatedData;
}

export interface StripeSubscription {
    current_period_end: number;
    ended_at: number;
    metadata: { [key: string]: string };
}

export interface StripeCreateCreatorSubscriptionResponse {
    client_secret: string;
}

export const isStripeAccountSetup = (account: StripeAccount | undefined): boolean => {
    if (account === undefined) {
        return false;
    }

    if (account.requirements?.disabled_reason !== '') {
        console.log(`Stripe account not setup. Reason: ${account.requirements?.disabled_reason}`);
        return false;
    }

    return true;
};

export const stripeAppearenceOptions = (
    colorMode: ColorMode,
    overides?: Appearance,
): Appearance => {
    return {
        theme: colorMode === 'light' ? 'stripe' : 'night',
        variables: {
            colorPrimary: '#6ef1d5',
        },
        ...overides,
    };
};
